import { render, staticRenderFns } from "./VenueCard.vue?vue&type=template&id=0385c19e&scoped=true&"
import script from "./VenueCard.vue?vue&type=script&lang=js&"
export * from "./VenueCard.vue?vue&type=script&lang=js&"
import style0 from "./VenueCard.vue?vue&type=style&index=0&id=0385c19e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0385c19e",
  null
  
)

export default component.exports